import '../../core/components/app-root/AppRoot.css';
import './panel.css';
export var GAP_SIZE = 8;
export var buttonIcon = '_1p91g306-3-8-0';
export var dismissedPanel = '_1p91g302-3-8-0';
export var drawer = '_1p91g304-3-8-0';
export var drawerContent = '_1p91g305-3-8-0';
export var gap = '_1p91g303-3-8-0';
export var panelContent = '_1p91g307-3-8-0';
export var resizeHandle = '_1p91g309-3-8-0';
export var resizeHandleContainer = '_1p91g308-3-8-0';
export var root = '_1p91g301-3-8-0';
export var rtlPanel = '_1p91g300-3-8-0';